import { render } from "./PointInfo.vue?vue&type=template&id=cd605cfa&scoped=true&ts=true"
import script from "./PointInfo.vue?vue&type=script&lang=ts"
export * from "./PointInfo.vue?vue&type=script&lang=ts"

import "./PointInfo.vue?vue&type=style&index=0&id=cd605cfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd605cfa"]])

export default __exports__